import fetcher from './fetchers'
let token = getToken()

function getToken () {
  return window.localStorage.getItem('__soa_token__')
}

export default {
  graphql (params, config = {}) {
    if (!token) {
      token = getToken()
    }
    return fetcher.post('/graphql', params, Object.assign({
      headers: {
        Authorization: token
      }
    }, config))
  },
  login (params) {
    return fetcher.get(`/login?sid=${params.sid}`)
  },
  wbLogin (params) {
    return fetcher.post(`/wbLogin`, params)
  },
  wbChangePassword (params) {
    if (!token) {
      token = getToken()
    }
    return fetcher.post(`/wbChangePassword`, params, {
      headers: {
        Authorization: token
      }
    })
  },
  getUserinfo () {
    if (!token) {
      token = getToken()
    }
    return fetcher.get('/get_userinfo', {
      headers: {
        Authorization: token
      }
    })
  },
  getAllDepartments () {
    if (!token) {
      token = getToken()
    }
    return fetcher.get('/getAllDepartments', {
      headers: {
        Authorization: token
      }
    })
  },
  getNotifyList () {
    if (!token) {
      token = getToken()
    }
    return fetcher.get('/getNotifyList', {
      headers: {
        Authorization: token
      }
    })
  },
  getRanking (params = {}) {
    if (!token) {
      token = getToken()
    }
    return fetcher.get(`/getRanking?year=${params.year}&month=${params.month}`, {
      headers: {
        Authorization: token
      }
    })
  },
  getRankingUserCredit (params = {}) {
    if (!token) {
      token = getToken()
    }
    return fetcher.get(`/getRankingUserCredit`, {
      headers: {
        Authorization: token
      }
    })
  },
  getRankingFirstDepartmentCredit (params = {}) {
    if (!token) {
      token = getToken()
    }
    return fetcher.get(`/getRankingFirstDepartmentCredit`, {
      headers: {
        Authorization: token
      }
    })
  },
  getRankingDepartmentCredit (params = {}) {
    if (!token) {
      token = getToken()
    }
    return fetcher.get(`/getRankingDepartmentCredit`, {
      headers: {
        Authorization: token
      }
    })
  },
  getGoodsLabelList (params = {}) {
    if (!token) {
      token = getToken()
    }
    return fetcher.post(`/getGoodsLabelList`, params, {
      headers: {
        Authorization: token
      }
    })
  }
}
